import { MantineSize } from "@mantine/core";
import Text from "./text";

interface IEmptyMessage {
  message: string;
  size?: MantineSize
}

const EmptyMessage = ({ message, size = 'md' }: IEmptyMessage) => (
  <Text size={size} ta={'center'} p={'md'}>{message}</Text>
)

export default EmptyMessage;